module.exports = __webpack_public_path__ + "static/media/GuardianGreaves.18963f3b.png";